// src/components/Seo.tsx

import * as React from "react";

import {
  APP_ENV,
} from "../lib/environment";

/* -------------------------------------------------------------------------- */
/* Types                                                                      */
/* -------------------------------------------------------------------------- */

type Props = {
  title:
    string;

  description:
    string;

  canonicalPath:
    string;
};

/* -------------------------------------------------------------------------- */
/* Helpers                                                                    */
/* -------------------------------------------------------------------------- */

function upsertMeta(
  selector:
    string,

  attributes:
    Record<string, string>,
): void {
  let element =
    document.head.querySelector<HTMLMetaElement>(
      selector,
    );

  if (
    !element
  ) {
    element =
      document.createElement(
        "meta",
      );

    document.head.appendChild(
      element,
    );
  }

  for (
    const [
      key,
      value,
    ] of Object.entries(
      attributes,
    )
  ) {
    element.setAttribute(
      key,
      value,
    );
  }
}

function upsertCanonical(
  href:
    string,
): void {
  let element =
    document.head.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );

  if (
    !element
  ) {
    element =
      document.createElement(
        "link",
      );

    element.rel =
      "canonical";

    document.head.appendChild(
      element,
    );
  }

  element.href =
    href;
}

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export function Seo(
  {
    title,
    description,
    canonicalPath,
  }:
    Props,
):
null {
  React.useEffect(
    () => {
      const canonicalUrl =
        new URL(
          canonicalPath,
          window.location.origin,
        ).toString();

      const robots =
        APP_ENV ===
        "prod"
          ? "index,follow"
          : "noindex,nofollow";

      document.title =
        title;

      upsertMeta(
        'meta[name="description"]',
        {
          name:
            "description",

          content:
            description,
        },
      );

      upsertMeta(
        'meta[name="robots"]',
        {
          name:
            "robots",

          content:
            robots,
        },
      );

      upsertMeta(
        'meta[property="og:title"]',
        {
          property:
            "og:title",

          content:
            title,
        },
      );

      upsertMeta(
        'meta[property="og:description"]',
        {
          property:
            "og:description",

          content:
            description,
        },
      );

      upsertMeta(
        'meta[property="og:url"]',
        {
          property:
            "og:url",

          content:
            canonicalUrl,
        },
      );

      upsertCanonical(
        canonicalUrl,
      );
    },
    [
      canonicalPath,
      description,
      title,
    ],
  );

  return null;
}